// extracted by mini-css-extract-plugin
export default {"Contain":"_Contain--aDCWl","TooltipText":"_TooltipText--lGuEZ","Alert":"_Alert--Zo9mx"};